import { DATE_UNAVAILABILITY_REASON } from '../../../../utils/availabilityStatus';
import { getAvailabilityRestrictionTooltip } from '../../../../utils/checkinAvailabilityMessages';

/** Generic tooltip shown for any check-in restricted day, regardless of the underlying reason. */
const RESTRICTED_CHECKIN_DAY_TOOLTIP = 'Zameldowanie niedostępne';

/** Tooltip for dates beyond the checkout availability map (max length of stay). */
const MAX_LOS_EXCEEDED_TOOLTIP = 'Przekroczono maksymalną długość pobytu';

/**
 * Disabled meta for a check-in map entry. Restricted check-in days always use the generic
 * `CHECKIN_DAY_NOT_ALLOWED` reason (generic tooltip); missing entries are treated as no inventory.
 * @returns {{ reason: string|null, availabilityStatus: null }}
 */
export const getCheckinDayMeta = (status) => {
  if (!status) {
    return { reason: DATE_UNAVAILABILITY_REASON.NO_INVENTORY, availabilityStatus: null };
  }
  if (status.available) {
    return { reason: null, availabilityStatus: null };
  }
  return {
    reason: status.reason === DATE_UNAVAILABILITY_REASON.NO_INVENTORY
      ? DATE_UNAVAILABILITY_REASON.NO_INVENTORY
      : DATE_UNAVAILABILITY_REASON.CHECKIN_DAY_NOT_ALLOWED,
    availabilityStatus: null,
  };
};

export const isNoInventoryStatus = (status) =>
  Boolean(status) && !status.available && status.reason === DATE_UNAVAILABILITY_REASON.NO_INVENTORY;

/**
 * Tooltip text for a disabled day, driven by {@link DATE_UNAVAILABILITY_REASON}.
 * @param {string|null|undefined} reason
 * @param {import('../../../../utils/availabilityStatus').DateAvailabilityStatus|{ suppressTooltip: true }|null|undefined} [availabilityStatus] - optional status for detailed checkout messages
 */
export const getDisabledDayTooltip = (reason, availabilityStatus) => {
  if (!reason || reason === DATE_UNAVAILABILITY_REASON.NO_INVENTORY) {
    return '';
  }
  if (availabilityStatus?.suppressTooltip) {
    return '';
  }
  if (reason === DATE_UNAVAILABILITY_REASON.MAX_LOS_EXCEEDED) {
    return MAX_LOS_EXCEEDED_TOOLTIP;
  }
  // Check-in restrictions always use the generic message (parent maps them to CHECKIN_DAY_NOT_ALLOWED).
  if (reason === DATE_UNAVAILABILITY_REASON.CHECKIN_DAY_NOT_ALLOWED) {
    return RESTRICTED_CHECKIN_DAY_TOOLTIP;
  }
  if (availabilityStatus) {
    return getAvailabilityRestrictionTooltip(availabilityStatus) || 'Termin niedostępny';
  }
  return getAvailabilityRestrictionTooltip({ available: false, reason }) || 'Termin niedostępny';
};
